import React, {Component, createRef} from "react";
import ReactDOM from "react-dom";
import * as R from "ramda";

class SimplePrintTable extends Component {
  constructor(props) {
    super(props);
    this.iframeRef = createRef();
  }

  componentDidMount() {
    const stylesAndLinks = document.querySelectorAll('style, link[rel="stylesheet"]');
    const stylesText = Array.from(stylesAndLinks)
      .map((styleOrLink) => {
        if (styleOrLink.tagName === "STYLE") {
          // Inline style tag
          return `<style>${styleOrLink.innerHTML}</style>`.trim();
        } else if (styleOrLink.tagName === "LINK") {
          // External CSS file
          const href = styleOrLink.getAttribute("href");
          if (href) {
            return `<link rel="stylesheet" href="${href}">`.trim();
          }
        }
        return ""; // Fallback
      })
      .join("");

    const collections = document.getElementsByClassName(!R.isNil(this.props.targetHtml) ? this.props.targetHtml : "MuiPaper-root");
    const muiPaperContent = collections[collections.length - 1]?.outerHTML || "";
    const iframe = this.iframeRef.current;
    if (iframe && iframe.contentWindow) {
      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <style>
              @page {
                margin: 0;
              }
              @media print {
                body {
                  -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */
                  color-adjust: exact; /* Firefox */
                }
                .MuiTableCell-head {
                  border-bottom: 2px solid rgba(224, 224, 224, 1) !important;
                }  
              }
              </style>
              ${stylesText}
          </head>
          <body>
            ${muiPaperContent}
          </body>
        </html>
        `);
      iframeDoc.close();

      const that = this;
      iframe.contentWindow.onload = function () {
        iframe.contentWindow.print();

        // Remove iframe from DOM
        that.props.onClearPrint();
      };
    }
  }

  componentWillUnmount() {
    const iframe = this.iframeRef.current;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.document.close();
    }
  }

  render() {
    return (
      <>
        {ReactDOM.createPortal(
          <iframe
            id="printWindow"
            name="printWindow"
            ref={this.iframeRef}
            style={{
              position: "absolute",
              top: "-939px",
              left: "-1242px",
              width: "1142px",
              height: "839px",
              visibility: "hidden",
            }}
            srcDoc="<!DOCTYPE html>"
          ></iframe>,
          document.body
        )}
      </>
    );
  }
}

export default SimplePrintTable;
